import { Lang } from "@cervval.js/common/src/i18n/languages";
import { Locale } from "@cervval.js/common/src/models/locale.model";
import { Environment } from "@cervval.js/common/src/services/app.service";
import { AuthErrorCode } from "./auth.errors";


//#region Get authentication possibilities routes

export interface SingleSignOnOption {
    iconCss: string[];
    text: string;
    url: string;
}

export interface AuthInfos {
    locale: Locale;
    env: Environment;
    appDisplayName?: string;
    appLogoUrl?: string;
    loginFormEnabled: boolean;
    autoRedirectIfSingleSSO: boolean;
    singleSignOnOptions?: SingleSignOnOption[];
}

/**
 * Routes registered by the server
 */
export interface AuthInfosRoutes<RP> {

    /**
     * Get authentication possibilities
     */
    getAuthInfos(params?: { lang?: Lang }, routeParams?: RP): Promise<AuthInfos>;
}

//#endregion Get authentication possibilities routes

//#region Login Form related routes

export interface LoginParameters {
    login: string;
    password: string;
    locale?: Locale;// if none provided, application will use the server default values
}

/**
 * Routes registered when using a LoginForm strategy (ie with username and password)
 */
export interface LoginFormAuthRoutes<AppLoginData, RP> {

    /**
     * Login user into the application from a login form
     */
    formLogin(params: LoginParameters, routeParams?: RP): Promise<{ redirectAfterLogin?: string, loginData: AppLoginData }>;

}

//#endregion Login Form related routes

// export interface AppWithLoginFormAuthRoutes

/**
 * Url of the login client application
 */
export const authUrls = {
    loginClientAppUrl: "/login",// url of the login application
    logoutUrl: "/logout"// url of the login application
};

export interface LoginDataRoutes<LoginData, RP> {

    /**
     * Get App login data
     */
    getLoginData(params?: unknown, routeParams?: RP): Promise<LoginData>;
}


export interface PasswordResetRoute<RP> {
    /**
     * Send the new password to the server
     * The user information must be retrieved from the session (routeParams).
     */
    resetPassword(params: { newPassword: string }, routeParams?: RP): Promise<void>;
}
//#region ValidationKey

export interface ValidationKeyParameters {
    login: string;
    validationKey?: string;
}

export interface ValidationKeyRoutes<UserData, RP> {

    /**
     * Request a validation key
     */
    askForValidationKey(params: ValidationKeyParameters, routeParams?: RP): Promise<boolean>;

    /**
     * Is validation key valid
     */
    isValidationKeyValid(params: ValidationKeyParameters, routeParams?: RP): Promise<{ userData: UserData | undefined, errorCode?: AuthErrorCode, erroMessage?: string }>;
}

//#endregion ValidationKey
